var engine = require('../src/store-engine')

var storages = require('../storages/all')
var plugins = [require('../plugins/json2')]

module.exports = engine.createStore(storages, plugins)



//////////////////
// WEBPACK FOOTER
// ./~/store/dist/store.legacy.js
// module id = 354
// module chunks = 0